import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { ScreenshotShowcase } from '../components/landing/ScreenshotShowcase';
import { CapabilitiesSection } from '../components/landing/CapabilitiesSection';
import { AppPreviewSection } from '../components/landing/AppPreviewSection';
import { PhilosophySection } from '../components/landing/PhilosophySection';
import { PrivacySection } from '../components/landing/PrivacySection';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-pond-dark selection:bg-pond-blue/30 selection:text-pond-cream" data-id="element-214">
      <SEOHead data-id="element-215" />
      <Hero data-id="element-216" />
      <ProblemSection data-id="element-217" />
      <FeaturesSection data-id="element-218" />
      <ScreenshotShowcase data-id="element-219" />
      <CapabilitiesSection data-id="element-220" />
      <AppPreviewSection data-id="element-221" />
      <PhilosophySection data-id="element-222" />
      <PrivacySection data-id="element-223" />
      <CTASection data-id="element-224" />
      <Footer data-id="element-225" />
    </div>;
}